module.exports = __webpack_public_path__ + "static/media/proj4_img5.bcdc4bd7.jpg";